import "./App.css";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import Mail from "./containers/mail";
import Home from "./containers/home";
import Navbar from "./components/navbar";
import About from "./containers/about";
import Service from "./containers/services";
import Testimonial from "./containers/testimonial";
import Portfolio from "./containers/portfolio";
import Team from "./containers/team";
import Contact from "./containers/contact";
import Performance from "./containers/performance";
import Fade from "react-reveal/Fade";
import Slide from "react-reveal/Slide";
import { useEffect } from "react";
import GoToTop from "./components/gototop";
import { Link } from "@mui/material";
import { Route, Routes } from "react-router-dom";
import Allcontainers from "./containers/allcontainer";
import AllProjects from "./containers/allProjects";
import ProjectDetail from "./containers/projectDetail/index";
import Maintenance from "./containers/maintenance";

const theme = createTheme({
  typography: {
    fontFamily: ["montserrat", "sans-serif"].join(","),
  },
  button: {
    fontFamily: ["montserrat", "sans-serif"].join(","),
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Routes>
        {/* <Route path="/" element={<Allcontainers />} />
        <Route path="/all-projects" element={<AllProjects />} />
        <Route path="/project-detail/:id/:name" element={<ProjectDetail />} /> */}
        <Route path="/" element={<Maintenance />} />
      </Routes>
    </ThemeProvider>
  );
}

export default App;
